module.exports = __webpack_public_path__ + "img/integral.6c48cc69.png";